module.exports = __webpack_public_path__ + "static/img/indexbg9.fb3da9a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/indexbg9.jpg
// module id = YDzI
// module chunks = 1